import {
  Button,
  Center,
  Container,
  Grid,
  Image,
  Paper,
  Space,
  Text,
  Title,
} from '@mantine/core';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'tabler-icons-react';
import useAuth from '../../hooks/useAuth';

function OnboardingDeclinedPage() {
  const navigate = useNavigate();
  const navigateOnboarding = (onboardingReferenceNumber: string) => {
    navigate(`/onboarding/activate/${onboardingReferenceNumber}`);
  };
  const { auth } = useAuth();

  return (
    <>
      <Helmet>
        <title>XPAY.World - Declined</title>
      </Helmet>
      <Container
        fluid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          shadow='xl'
          style={{ maxWidth: 1000, borderRadius: 20 }}
          sx={{
            '@media (max-width: 755px)': {
              padding: 20,
              margin: 10,
            },
            '@media (min-width: 755px)': {
              padding: 100,
            },
            '@media (min-width: 1200px)': {
              padding: 150,
            },
          }}
        >
          <Grid justify='center'>
            <Grid.Col span={12}>
              <Center>
                <Image
                  style={{ maxWidth: 243, maxHeight: 193 }}
                  fit='contain'
                  src='/images/declined.svg'
                  alt='declined.svg'
                />
              </Center>
            </Grid.Col>
            <Grid.Col>
              <Title style={{ fontSize: '2rem' }} align='center'>
                Sorry ...
              </Title>
            </Grid.Col>
            <Grid.Col>
              <Space />
            </Grid.Col>
            <Grid.Col>
              <Text style={{ fontSize: '1rem' }} align='center'>
                Thank you so much for your patience! Unfortunately, after
                reviewing your submission, we can’t approve your application
                this time.
              </Text>
            </Grid.Col>
            <Grid.Col>
              <Space />
            </Grid.Col>
            <Grid.Col>
              <Text style={{ fontSize: '1rem' }} align='center'>
                Wishing the best for you and your business!
              </Text>
            </Grid.Col>
            <Grid.Col>
              <Center mt={26}>
                <Button
                  onClick={() => {
                    auth?.onboardingReferenceNumber &&
                      navigateOnboarding(auth?.onboardingReferenceNumber);
                  }}
                  rightIcon={<ArrowRight size={16} />}
                  data-cy='updateButton'
                >
                  Update Application
                </Button>
              </Center>
            </Grid.Col>
          </Grid>
        </Paper>
      </Container>
    </>
  );
}

export default OnboardingDeclinedPage;
